export default "__VITE_ASSET__DynrLVjN__"